import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';

export const Country = {
  id: 'country',
  displayName: <FormattedMessage defaultMessage='Country' description='filterOptions.country' id='u24cHM' />,
  type: OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS,
  filterValue: 'countryCode',
  expectsArgumentAsArray: true,

  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_OR_ISNOT_MULTI_OPTIONS, criteriaInformations, existingFiltersHelpers);
  },
};
